<template>
  <div class="user-bank">
    <div class="userTitle1">
      <span class="iconfont icontianjiayinhangka el-icon-bank-card"></span>
      银行卡绑定
    </div>
    <div v-if="bankCardCount > bankArr.length" class="userTitle2">
      <!-- <span>添加银行卡</span> -->
      <div class="tabsFlex">
        <div
          v-for="(item, i) of tabs"
          :key="i"
          @click="onChange(i)"
          class="tabitem"
          :class="{ avtit: item.id == index }"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="addBank" v-if="index == 0 && bankCardCount > bankArr.length">
      <div class="left">
        <div class="userInput userInput-flex">
          <div class="lable">*开户人姓名：</div>
          <el-input
            size="medium"
            v-model="userInfo.realName"
            placeholder="请输入账户姓名"
            disabled
          ></el-input>
        </div>
        <div class="userInput userInput-flex">
          <div class="lable">*开户银行：</div>
          <el-select
            popper-class="userSelect"
            size="medium"
            v-model="queryObj"
            value-key="name"
            placeholder="请选择"
          >
            <template v-slot:prefix>
              <img
                v-show="queryObj.imgUrl"
                class="prefixUrl"
                :src="$common.getImgUrl(queryObj.imgUrl)"
              />
            </template>
            <el-option
              v-for="item in querybank"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
              <img class="banicon" :src="$common.getImgUrl(item.imgUrl)" />
              {{ item.name }}
            </el-option>
          </el-select>
        </div>
        <div v-if="queryObj.name == '数字货币'" class="">
          <div class="userInput userInput-flex">
            <div class="lable">*链路：</div>
            <el-input
              size="medium"
              v-model="bankObj.branch"
              clearable
              placeholder="请输入ERC20或是TRC20"
            ></el-input>
          </div>
          <div class="userInput userInput-flex">
            <div class="lable">*地址：</div>
            <el-input
              size="medium"
              type="text"
              v-model="bankObj.number"
              clearable
              placeholder="请输入钱包地址"
            ></el-input>
          </div>
        </div>
        <div v-if="queryObj.name != '数字货币'">
          <div class="userInput userInput-flex">
            <div class="lable">*银行账号：</div>
            <el-input
              size="medium"
              v-model="bankObj.number"
              maxlength="23"
              clearable
              placeholder="请输入银行卡账号"
            ></el-input>
          </div>
          <div class="userInput userInput-flex">
            <div class="lable">*开户支行信息：</div>
            <el-input
              size="medium"
              v-model="bankObj.branch"
              clearable
              placeholder="请输入开户支行"
            ></el-input>
          </div>
        </div>
        <div v-if="bind_sms" class="userInput userInput-flex">
          <div class="lable">*手机号：</div>
          <el-input
            size="medium"
            disabled
            v-model="bankObj.phone"
            maxlength="11"
            clearable
            placeholder="请输入手机号"
          ></el-input>
        </div>
        <div v-if="bind_sms" class="userInput userInput-flex">
          <div class="lable">*验证码：</div>
          <el-input
            size="medium"
            v-model="bankObj.smsCode"
            maxlength="8"
            clearable
            placeholder="请输入验证码"
            style="width: 40%; margin-right: 3%"
          >
          </el-input>
          <el-button
            @click="getSmsCode"
            size="small"
            type="primary"
            style="height: 36px"
            >{{ bntText }}</el-button
          >
        </div>
        <div class="button">
          <span class="btnUser1" @click="addbank">提交</span>
        </div>
      </div>
      <div class="right">
        <p>说明：</p>
        <p class="coRed">
          1.绑定的银行卡开户姓名需与绑定的姓名相符，否则无法绑定。
        </p>
        <p>2.银行卡绑定主要用于会员提现使用，如须解绑，请与在线客服联系。</p>
        <p>3.请注意一旦银行卡绑定不能修改，请认真核对填写。</p>
        <p>4.会员提现时请选择需要提现到的已绑定银行卡，并仔细核对。</p>
      </div>
    </div>
    <div v-if="index == 1">
      <addcurrency></addcurrency>
    </div>
    <div v-if="index == 2">
      <addWallet></addWallet>
    </div>
    <div class="userTitle2">
      <span>已绑定银行卡</span>
    </div>
    <el-table :data="bankArr" class="myTable">
      <el-table-column prop="name" label="银行名称">
        <template v-slot:scope>
          <span v-if="scope.row.type == 2">origo钱包</span>
          <span v-else>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="银行logo">
        <template v-slot:scope>
          <!-- <img
                        v-if="scope.row.type == 2"
                        class="bankLogo"
                        src="../../static/img/wallet.png"
                    /> -->
          <img v-if="scope.row.type == 2" class="bankLogo" src="" />
          <img
            v-else
            class="bankLogo"
            :src="$common.getImgUrl(scope.row.imgUrl)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="branch" label="所属支行"></el-table-column>
      <el-table-column
        :formatter="onNumber"
        prop="number"
        label="卡号"
      ></el-table-column>
      <el-table-column
        :formatter="onTime"
        prop="updatedAt"
        label="绑定时间"
      ></el-table-column>
      <el-table-column label="操作">
        <template v-slot:scope>
          <el-button
            @click="deleteRow(scope, bankArr)"
            type="text"
            size="small"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AddCurrency from "../../components/addCurrency/addCurrency";
import AddWallet from "../../components/addWallet/addWallet";
export default {
  components: {
    addcurrency: AddCurrency,
    addWallet: AddWallet,
  },
  data() {
    return {
      tabs: [
        // { name: "添加origo钱包", id: 2 },
        { name: "添加银行卡/数字货币", id: 0 },
        // { name: "添加数字货币", id: 1 },
      ],
      querybank: [],
      queryObj: {},
      bankObj: {
        branch: "",
        number: "",
        phone: "", //绑定银行卡手机号
        smsCode: "",
        type: 0,
      },
      bind_sms: "",
      index: 0,
      bankCardCount: "",
      isGetSMSShow: true,
      bntText: "获取验证码",
      Interval: null,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "bankArr"]),
  },
  created() {
    this.$nkhttp.http(this.$api.querybank, null, "get", (data) => {
      this.querybank = data;
    });
    this.getBindBankNum();
    this.getBindBankSMS();
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$http
        .get(this.$api.members + "/" + this.$common.getUser().user_id, "", true)
        .then((res) => {
          this.bankObj.phone = res.data.phone || "";
          if (!res.data.withdrawPassWordState) {
            this.$alert("请先设置交易密码?", "提示", {
              type: "warning",
              showClose: false,
              callback: (action) => {
                this.$router.push({ path: "/user/modifyWithPsw" });
              },
            });
            return;
          }
          if (!res.data.realName) {
            this.$alert("请先设置真实姓名再添加银行卡?", "提示", {
              type: "warning",
              showClose: false,
              callback: (action) => {
                this.$router.push({ path: "/user/info" });
              },
            });
            return;
          }
          if (!res.data.phone) {
            this.$alert("请先绑定手机号再添加银行卡?", "提示", {
              type: "warning",
              showClose: false,
              callback: (action) => {
                this.$router.push({ path: "/user/info" });
              },
            });
            return;
          }
        });
    },
    onChange(i) {
      this.index = this.tabs[i].id;
    },
    addbank() {
      if (!this.queryObj.name) {
        this.$message.error("请选择银行");
        return;
      }
      let _str = this.bankObj.number.replace(/\s*/g, "");
      if (this.queryObj.name == "数字货币") {
        if (this.bankObj.number == "") {
          this.$message.error("请输入钱包地址");
          return;
        }
      } else {
        if (_str.length < 10 || _str.length > 19) {
          this.$message.error("卡号输入有误");
          return;
        }
      }
      if (!this.bankObj.branch && this.queryObj.name == "数字货币") {
        this.$message.error("请输入ERC20或是TRC20");
        return;
      }
      if (!this.bankObj.branch) {
        this.$message.error("请输入支行");
        return;
      }
      let _obj = {
        ...this.bankObj,
        name: this.queryObj.name,
        memberId: this.userInfo.userId,
        account: this.userInfo.realName,
        clientItem: window.childCode, //子平台id字段
      };
      _obj.number = _str;
      this.$nkhttp.http(this.$api.addbank, _obj, "post", () => {
        this.$message.success("添加成功");
        this.$nkhttp.getBank();
        this.queryObj = {};
        this.bankObj = {
          name: "",
          branch: "",
          number: "",
          type: 0,
        };
      });
    },
    deleteRow(_scope, _bankArr) {
      this.$nkhttp.http(
        this.$api.removeBack + "/" + _scope.row.id,
        null,
        "delete",
        () => {
          this.$message.success("删除成功");
          let _arr = [..._bankArr];
          _arr.splice(_scope.$index, 1);
          this.$store.commit("setBankArr", _arr);
        }
      );
    },
    onTime(...arr) {
      return this.$utils.getTime(arr[2]);
    },
    onNumber(...arr) {
      return this.$utils.hideMiddle(arr[2]);
    },
    //获取银行卡绑定数量
    getBindBankNum() {
      this.$nkhttp.http(this.$api.bindBankNnm, null, "get", (data) => {
        if (data) {
          this.bankCardCount = data.svalue.bank_card_count || 0;
          this.bind_sms = data.svalue.bind_sms;
        }
      });
    },
    getBindBankSMS() {
      this.$nkhttp.http(this.$api.getBindBankSMS, null, "get", (data) => {
        if (data) {
          this.bind_sms = data.bindSmsOpen;
        }
      });
    },
    //获取手机验证码
    async getSmsCode() {
      if (!this.isGetSMSShow) return;
      this.isGetSMSShow = false;
      const res = await this.$http.get(
        this.$api.sendSmsCode,
        "/" + this.bankObj.phone + "?functionId=3",
        true
      );

      if (res.code == 0) {
        this.smsCountdown(60);
      } else {
        this.isGetSMSShow = true;
        this.bntText = "重新发送";
        this.$message.error("短信验证获取失败，请重新获取.");
      }
    },
    //倒计时
    smsCountdown(timer) {
      this.Interval = setInterval(() => {
        timer--;
        if (timer > 0) {
          this.bntText = timer + "(秒)";
        } else {
          this.bntText = "重新发送";
          (this.isGetSMSShow = true), clearInterval(this.Interval);
        }
      }, 1000);
    },
  },
  watch: {
    ["bankObj.number"](val) {
      if (val) {
        if (this.queryObj.name != "数字货币") {
          this.bankObj.number = val
            .replace(/\D/g, "")
            .replace(/....(?!$)/g, "$& ");
        } else {
          this.bankObj.number = val;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.el-input--suffix .el-input__inner {
  padding-right: 15px;
}
.userInput-flex {
  display: flex;
  justify-content: space-around;
  .lable {
    width: 32%;
    line-height: 36px;
    text-align: right;
  }
}
.tabsFlex {
  display: flex;
  margin-left: 68px;
  .tabitem {
    color: #666;
    font-size: 17px;
    margin-right: 120px;
  }
  .avtit {
    border-bottom: 2px solid #000;
  }
}
.user-bank {
  .addBank {
    height: 450px;
    padding-top: 40px;
    display: flex;
    .left {
      margin-left: 65px;
      .button {
        text-align: center;
      }
    }
    .right {
      height: 322px;
      width: 508px;
      box-sizing: border-box;
      padding: 20px 30px;
      font-size: 14px;
      color: #666;
      border: 1px solid #ccc;
      border-radius: 10px;
      margin-left: 160px;
      p {
        margin-bottom: 20px;
      }
    }
  }
  .bankLogo {
    width: 30px;
    height: 30px;
  }
}
</style>